import { render } from "./Plate.vue?vue&type=template&id=7c8b2197"
import script from "./Plate.vue?vue&type=script&lang=js"
export * from "./Plate.vue?vue&type=script&lang=js"

import "./Plate.vue?vue&type=style&index=0&id=7c8b2197&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__